import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberHorizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronGrabberHorizontal"><Path fillRule="evenodd" clipRule="evenodd" d="M10.4144 8.00015L6.41436 12.0002L10.4144 16.0002L9.00015 17.4144L3.58594 12.0002L9.00015 6.58594L10.4144 8.00015ZM15.0001 6.58599L20.4143 12.0002L15.0001 17.4144L13.5859 16.0002L17.5859 12.0002L13.5859 8.0002L15.0001 6.58599Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronGrabberHorizontal;
